export default __webpack_public_path__ + "static/keyrus-ai-dark-7befb777f916ea2b69c183229f1d82e3.svg";